export default __webpack_public_path__ + "styles/icons/foamCup.svg";